import { render, staticRenderFns } from "./SystemInServices.vue?vue&type=template&id=bdb81912&"
import script from "./SystemInServices.vue?vue&type=script&lang=js&"
export * from "./SystemInServices.vue?vue&type=script&lang=js&"
import style0 from "./SystemInServices.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports